import { FaEye } from "react-icons/fa6";
import { Link } from "@tanstack/react-router";

interface ViewDetailButtonProps {
  buttonText?: string;
  detailUrl?: string;
  className?: string;
}

const ViewDetailButton = ({
  buttonText = "View Details",
  detailUrl,
  className,
}: ViewDetailButtonProps) => {
  // Parse URLs that contain query strings so TanStack Router handles them correctly.
  // Link's `to` prop doesn't parse query strings from combined path+query strings.
  const hasQuery = detailUrl?.includes("?");
  const linkProps = hasQuery
    ? (() => {
        const url = new URL(detailUrl!, window.location.origin);
        return {
          to: url.pathname,
          search: Object.fromEntries(url.searchParams) as Record<string, string>,
        };
      })()
    : { to: detailUrl };

  return (
    <Link {...(linkProps as any)}>
      <button className={`ox-button w-26 px-2 py-1 ${className}`}>
        <FaEye className="mr-4 align-middle" size={18} />
        {buttonText}
      </button>
    </Link>
  );
};

export default ViewDetailButton;
